import Vue from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import '@/assets/css/common.scss'
import { getCookie, delCookie, setCookie } from '@/utils/cookie'
import { getSmsModel, getEmailModel } from '@/utils/index'
import checkPassword from '@/utils/checkPass'
import checkNotLoginPassword from '@/utils/checkPwd'
import { passwordEncryption } from '@/utils/rsa'
import { serverUrlFun } from '@/utils/serverUrl'
import { userEditPwdFun } from '@/utils/userEditPwd'
import httpStatusCode from '@/utils/httpStatusCode'
import i18n from '@/utils/i18n'
import 'moment/locale/zh-cn'
import StandardTable from '@/common/table'
import SearchSelect from '@/common/searchSelect'
import detailDrawer from '@/common/detailDrawer'
import { formLayout, wrapperCol, drawerWidth } from '@/utils/common'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(Antd)

Vue.component('standard-table', StandardTable)
Vue.component('search-select', SearchSelect)
Vue.component('detail-drawer', detailDrawer)

router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    if (localStorage.getItem('accessToken')) {
      router.push({
        path: '/home',
      })
    } else {
      router.push({
        path: '/login',
      })
    }
  } else {
    next()
  }
})

Vue.prototype.$cookieStore = {
  setCookie,
  getCookie,
  delCookie,
}
Vue.prototype.$getSmsModel = getSmsModel
Vue.prototype.$getEmailModel = getEmailModel
Vue.prototype.$checkPassword = checkPassword
Vue.prototype.$checkNotLoginPassword = checkNotLoginPassword
Vue.prototype.$passwordEncryption = passwordEncryption
Vue.prototype.$serverUrlFun = serverUrlFun
Vue.prototype.$userEditPwdFun = userEditPwdFun
Vue.prototype.$GLOBA = httpStatusCode

Vue.prototype.$formLayout = formLayout
Vue.prototype.$wrapperCol = wrapperCol
Vue.prototype.$drawerWidth = drawerWidth

const $vue = new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
  data: {
    eventHub: new Vue(),
  },
}).$mount('#app')

export default $vue
